import * as Yup from "yup";
import { phoneNumberSchema } from "utils/schemas";

export const companyProfileSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Company name is required")
    .max(255, "Name is too long"),
  address: Yup.string()
    .trim()
    .required("Address is required")
    .max(500, "Address is too long"),
  phone: phoneNumberSchema.required("Phone is required"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .email("Enter a valid email")
    .max(255, "Email is too long"),
  gstNumber: Yup.string()
    .trim()
    .required("GST number is required")
    .max(64, "GST number is too long"),
});

export default companyProfileSchema;
